const A = "textarea", E = {
  VALID: "valid",
  ERROR: "error",
  DEFAULT: "default"
}, T = {
  TRUE: "true",
  FALSE: "false",
  DEFAULT: "default"
}, R = {
  SOFT: "soft",
  HARD: "hard"
};
export {
  A as TEXTAREA_BASE_CLASS,
  T as TEXTAREA_SPELLCHECK,
  E as TEXTAREA_STATES,
  R as TEXTAREA_WRAP
};
